export enum PubAdsMethods {
	CLEAR_TARGETING = 'clearTargeting',
	COLLAPSE_EMPTY_DIVS = 'collapseEmptyDivs',
	DISABLE_INITIAL_LOAD = 'disableInitialLoad',
	ENABLE_LAZY_LOAD = 'enableLazyLoad',
	ENABLE_SINGLE_REQUEST = 'enableSingleRequest',
	GET_TARGETING = 'getTargeting',
	REFRESH = 'refresh',
	SET_TARGETING = 'setTargeting',
}

export enum BannerType {
	ADVANCED = 'advanced',
	MOBILE_ADVANCED = 'mobileAdvanced',
	TOP = 'top',
}

export enum AdTargetingKey {
	DISCIPLINE = 'discipline',
}

export interface ILazyLoadParams {
	fetchMarginPercent?: number;
	renderMarginPercent?: number;
	mobileScaling?: number;
}

export interface IGoogleTagCmd {
	push: (callback: () => void) => void;
}

export interface IPubAds {
	[PubAdsMethods.CLEAR_TARGETING]?: (key: AdTargetingKey) => void;
	[PubAdsMethods.COLLAPSE_EMPTY_DIVS]?: () => void;
	[PubAdsMethods.DISABLE_INITIAL_LOAD]?: () => void;
	[PubAdsMethods.ENABLE_LAZY_LOAD]?: (params: ILazyLoadParams) => void;
	[PubAdsMethods.ENABLE_SINGLE_REQUEST]?: () => void;
	[PubAdsMethods.GET_TARGETING]: (key: AdTargetingKey) => string[];
	[PubAdsMethods.REFRESH]?: (slots: IDefinedSlot[]) => void;
	[PubAdsMethods.SET_TARGETING]?: (key: AdTargetingKey, value: string | string[]) => void;
	getSlots?: () => IDefinedSlot[];
	addEventListener?: (
		eventName: 'slotRenderEnded',
		listener: (event: ISlotRenderEndedEvent) => void,
	) => void;
}

export interface IDefinedSlot {
	addService?: (pubAds: IPubAds) => void;
	defineSizeMapping?: (mapping: ISizeMapping) => void;
	getSlotElementId: () => string;
}

export interface ISizeMapping {
	addSize?: (viewportSize: [number, number], slotSize: [number, number][]) => ISizeMapping;
	build?: () => ISizeMapping;
}

export interface IGoogleTag {
	cmd?: IGoogleTagCmd;
	defineSlot?: (adUnitPath: string, size: [number, number], id?: string) => IDefinedSlot;
	display?: (containerId: string) => void;
	pubads?: () => IPubAds;
	pubadsReady: boolean;
	sizeMapping?: () => ISizeMapping;
	enableServices?: () => void;
}

export interface IAdUnit {
	dimensions: [number, number];
	code: string;
	containerID: string;
}

export interface IAdTargetingRule {
	key: string;
	value: string;
}

export interface ISlotRenderEndedEvent {
	slot?: {
		getSlotElementId?: () => string;
	};
	isEmpty?: boolean;
	size?: unknown;
	advertiserId?: number;
	lineItemId?: number;
	creativeId?: number;
}

export type TAdSlots = {
	[key in BannerType]?: IDefinedSlot[];
};

export interface IGamReadyEvent extends CustomEvent {
	detail: {
		units?: IAdUnit[];
		targeting?: IAdTargetingRule[];
	};
}
